export default __webpack_public_path__ + "static/media/emosional.f79148e4.png";